// Country helpers for the Expert guides category system.
// Flags come from flagcdn.com (a standard, reliable flag CDN). "General"
// guides have no country and therefore no flag.

const NAME_TO_CODE = {
  india: "in", china: "cn", "south korea": "kr", korea: "kr", taiwan: "tw",
  greece: "gr", "hong kong": "hk", singapore: "sg", malaysia: "my",
  nigeria: "ng", pakistan: "pk", bangladesh: "bd", "sri lanka": "lk",
  nepal: "np", vietnam: "vn", indonesia: "id", thailand: "th", japan: "jp",
  "united arab emirates": "ae", uae: "ae", "saudi arabia": "sa", qatar: "qa",
  kuwait: "kw", bahrain: "bh", oman: "om", jordan: "jo", lebanon: "lb",
  turkey: "tr", cyprus: "cy", germany: "de", france: "fr", italy: "it",
  spain: "es", portugal: "pt", netherlands: "nl", ireland: "ie", poland: "pl",
  romania: "ro", "united states": "us", usa: "us", canada: "ca", brazil: "br",
  mexico: "mx", colombia: "co", egypt: "eg", kenya: "ke", ghana: "gh",
  "south africa": "za", zimbabwe: "zw", philippines: "ph", myanmar: "mm",
  kazakhstan: "kz", uzbekistan: "uz", russia: "ru", ukraine: "ua",
};

// Suggested countries for the admin category picker (free text still allowed).
export const COUNTRY_OPTIONS = [
  "India", "China", "South Korea", "Taiwan", "Greece", "Hong Kong",
  "Singapore", "Malaysia", "Nigeria", "Pakistan", "Bangladesh", "Sri Lanka",
  "Nepal", "Vietnam", "Indonesia", "Thailand", "Japan",
  "United Arab Emirates", "Saudi Arabia", "Qatar", "Kuwait", "Turkey",
  "Cyprus", "Germany", "France", "Italy", "Spain", "Portugal", "Netherlands",
  "Ireland", "Poland", "Romania", "United States", "Canada", "Brazil",
  "Mexico", "Colombia", "Egypt", "Kenya", "Ghana", "South Africa",
  "Philippines", "Kazakhstan", "Uzbekistan",
];

export const isGeneral = (cat) => !cat || cat.trim().toLowerCase() === "general";

export const countryCode = (name) =>
  name ? NAME_TO_CODE[name.trim().toLowerCase()] || null : null;

// Returns { src, srcSet } for a small flag, or null when there's no reliable
// flag (General category, or an unrecognised country) — so we never render a
// broken/placeholder image.
export const flagProps = (name) => {
  const code = countryCode(name);
  if (!code) return null;
  return {
    src: `https://flagcdn.com/20x15/${code}.png`,
    srcSet: `https://flagcdn.com/40x30/${code}.png 2x`,
  };
};
